<div class="dashboard-overview-component container-fluid page-container">
    <div class="row row-spacer">
        <div class="col-lg-12">
            <div [ngClass]="{ card: !isMobile }">
                <div
                    *ngIf="!isMobile && !!debtorKey"
                    class="card-header"
                    i18n="Customer Snapshot card header"
                >
                    Customer Snapshot
                </div>
                <div
                    *ngIf="!isMobile && !debtorKey"
                    class="card-header"
                    i18n="Account Snapshot card header"
                >
                    Account Snapshot
                </div>
                <ng-container *ngIf="accountSnapshotDataSource.error$ | async">
                    <div class="card-error">
                        <p>{{ dataSourceErrorCopy }}</p>
                    </div>
                </ng-container>
                <ng-container *ngIf="!(accountSnapshotDataSource.error$ | async)">
                    <lsq-circle-loader
                        *ngIf="accountSnapshotDataSource.loading$ | async"
                    ></lsq-circle-loader>
                    <div
                        *ngIf="!(accountSnapshotDataSource.loading$ | async)"
                        class="account-snapshot-body"
                        [ngClass]="{ 'card-body': !isMobile }"
                    >
                        <div
                            class="snapshot-item mobile-amount-cluster-card"
                            (click)="
                                goToLinkOnMobile(
                                    !!debtorKey
                                        ? getCustomerLink(agingByCustomerRouterLinkUrl)
                                        : agingRouterLinkUrl
                                )
                            "
                        >
                            <dashboard-amount-cluster
                                [useCurrencyPipe]="true"
                                [label]="
                                    (accountSnapshotData$ | async)?.unpaidInvoicesCount +
                                    ' Unpaid Invoices'
                                "
                                i18n-label="[# of unpaid invoices] Unpaid Invoices"
                                [linkDestination]="
                                    !!debtorKey
                                        ? getCustomerLink(agingByCustomerRouterLinkUrl)
                                        : agingRouterLinkUrl
                                "
                                tooltipText="Invoices that your customers haven't paid yet."
                                i18n-tooltipText="Unpaid Invoices dashboard tooltip"
                                [value]="(accountSnapshotData$ | async)?.unpaidInvoicesAmount"
                            >
                            </dashboard-amount-cluster>
                            <lsq-icon
                                *ngIf="isMobile"
                                [type]="icons.ChevronRight"
                                [color]="color.Gray"
                            ></lsq-icon>
                        </div>
                        <div
                            class="snapshot-item mobile-amount-cluster-card"
                            (click)="
                                goToLinkOnMobile(
                                    !!debtorKey
                                        ? getCustomerLink(purchasesByCustomerRouterLinkUrl)
                                        : purchasesRouterLinkUrl
                                )
                            "
                        >
                            <dashboard-amount-cluster
                                [useCurrencyPipe]="true"
                                [label]="
                                    (accountSnapshotData$ | async)?.pendingInvoicesCount +
                                    ' Pending Invoices'
                                "
                                i18n-label="[# of pending invoices] Pending Invoices"
                                [linkDestination]="
                                    !!debtorKey
                                        ? getCustomerLink(purchasesByCustomerRouterLinkUrl)
                                        : purchasesRouterLinkUrl
                                "
                                tooltipText="Invoices that are being processed and have not yet been purchased by LSQ."
                                i18n-tooltipText="Pending Invoices dashboard tooltip"
                                [value]="(accountSnapshotData$ | async)?.pendingInvoicesAmount"
                            >
                            </dashboard-amount-cluster>
                            <lsq-icon
                                *ngIf="isMobile"
                                [type]="icons.ChevronRight"
                                [color]="color.Gray"
                            ></lsq-icon>
                        </div>
                        <div
                            class="snapshot-item mobile-amount-cluster-card"
                            (click)="
                                goToLinkOnMobile(
                                    !!debtorKey
                                        ? getCustomerLink(collectionsByCustomerRouterLinkUrl)
                                        : collectionsRouterLinkUrl,
                                    { startDate: startOfMonth(today), endDate: today }
                                )
                            "
                        >
                            <dashboard-amount-cluster
                                [useCurrencyPipe]="true"
                                [label]="
                                    (accountSnapshotData$ | async)?.paymentsCollectedMtdCount +
                                    ' Payments Collected Mtd'
                                "
                                i18n-label="
                                    [# of payments collected month-to-date] Payments Collected Mtd
                                "
                                [linkDestination]="
                                    !!debtorKey
                                        ? getCustomerLink(collectionsByCustomerRouterLinkUrl)
                                        : collectionsRouterLinkUrl
                                "
                                [queryParams]="{
                                    startDate: startOfMonth(today),
                                    endDate: today
                                }"
                                tooltipText="The month to date sum of payments that LSQ has collected from your customers."
                                i18n-tooltipText="Payments Collected dashboard tooltip"
                                [value]="(accountSnapshotData$ | async)?.paymentsCollectedMtdAmount"
                            >
                            </dashboard-amount-cluster>
                            <lsq-icon
                                *ngIf="isMobile"
                                [type]="icons.ChevronRight"
                                [color]="color.Gray"
                            ></lsq-icon>
                        </div>
                        <div
                            class="snapshot-item mobile-amount-cluster-card"
                            (click)="
                                goToLinkOnMobile(
                                    !!debtorKey
                                        ? getCustomerLink(ineligiblesByCustomerRouterLinkUrl)
                                        : ineligiblesRouterLinkUrl
                                )
                            "
                        >
                            <dashboard-amount-cluster
                                [useCurrencyPipe]="true"
                                [label]="
                                    (accountSnapshotData$ | async)?.ineligibleCount +
                                    ' Ineligible Invoices'
                                "
                                i18n-label="[# of ineligible invoices] Ineligible Invoices"
                                [linkDestination]="
                                    !!debtorKey
                                        ? getCustomerLink(ineligiblesByCustomerRouterLinkUrl)
                                        : ineligiblesRouterLinkUrl
                                "
                                tooltipText="Invoices that LSQ will not fund against. An invoice may become ineligible because it is: missing verification, past due, over credit limit, in dispute, etc."
                                i18n-tooltipText="Ineligible Invoices dashboard tooltip"
                                [value]="(accountSnapshotData$ | async)?.ineligibleAmount"
                            >
                            </dashboard-amount-cluster>
                            <lsq-icon
                                *ngIf="isMobile"
                                [type]="icons.ChevronRight"
                                [color]="color.Gray"
                            ></lsq-icon>
                        </div>
                        <div
                            class="snapshot-item mobile-amount-cluster-card"
                            (click)="
                                goToLinkOnMobile(
                                    !!debtorKey
                                        ? getCustomerLink(collectionsByCustomerRouterLinkUrl)
                                        : collectionsRouterLinkUrl
                                )
                            "
                        >
                            <dashboard-amount-cluster
                                [useCurrencyPipe]="true"
                                [label]="
                                    (accountSnapshotData$ | async)?.pendingCollectionsCount +
                                    ' Pending Collections'
                                "
                                i18n-label="[# of pending collections] Pending Collections"
                                [linkDestination]="
                                    !!debtorKey
                                        ? getCustomerLink(collectionsByCustomerRouterLinkUrl)
                                        : collectionsRouterLinkUrl
                                "
                                tooltipText="Invoice payments that LSQ received from your customers but have not yet posted to your account. Collections post to your account at the end of the business day and show as pending until then."
                                i18n-tooltipText="Pending Collections dashboard tooltip"
                                [value]="(accountSnapshotData$ | async)?.pendingCollectionsAmount"
                            >
                            </dashboard-amount-cluster>
                            <lsq-icon
                                *ngIf="isMobile"
                                [type]="icons.ChevronRight"
                                [color]="color.Gray"
                            ></lsq-icon>
                        </div>
                        <div
                            *ngIf="!debtorKey"
                            id="funds-outstanding-card-tour"
                            class="snapshot-item mobile-amount-cluster-card"
                        >
                            <dashboard-amount-cluster
                                [useCurrencyPipe]="true"
                                label="Funds Outstanding"
                                i18n-label="[Dollar amount of funds outstanding] Funds Outstanding"
                                tooltipText="The outstanding balance of funds that LSQ has advanced to your account."
                                i18n-tooltipText="Funds Outstanding dashboard tooltip"
                                [linkDestination]="availableFundsSummaryRouterLinkUrl"
                                [value]="(accountSnapshotData$ | async)?.fundsOutstanding"
                            >
                            </dashboard-amount-cluster>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
    <div class="row row-spacer">
        <div class="col-lg-6 row-spacer-md">
            <div id="aging-summary-card" class="card">
                <div class="card-header">
                    <span i18n="Aging Summary dashboard graph card header">Aging Summary</span>
                    <lsq-icon-popover
                        i18n-text="Aging Summary dashboard graph card header popover"
                        text="A summary of all your unpaid invoices and the length of time they've been outstanding."
                    >
                    </lsq-icon-popover>
                </div>
                <div class="card-body">
                    <lsq-circle-loader
                        *ngIf="agingOverviewDataSource.loading$ | async"
                    ></lsq-circle-loader>
                    <div class="chart-section" *ngIf="!(agingOverviewDataSource.loading$ | async)">
                        <div
                            class="chart-container"
                            *ngIf="invoiceCount > 0 && (agingOverviewData$ | async)"
                        >
                            <div
                                class="chart-center"
                                *ngIf="!(agingOverviewDataSource.loading$ | async)"
                            >
                                <div class="number-of-invoices">
                                    {{ invoiceCount | number }}
                                </div>
                                <div
                                    class="invoices-label"
                                    i18n="invoices count label for doughnut graph"
                                >
                                    {invoiceCount, plural, =1 {invoice} other {invoices}}
                                </div>
                                <div *ngIf="agingOverviewData$ | async" class="total-dollar-amount">
                                    {{
                                        (agingOverviewData$ | async).amountCurrent +
                                            (agingOverviewData$ | async).amountDayOne +
                                            (agingOverviewData$ | async).amountDayThirtyOne +
                                            (agingOverviewData$ | async).amountDaySixtyOne
                                            | currency
                                    }}
                                </div>
                            </div>
                            <lsq-chart
                                class="doughnut-chart"
                                [options]="chartOptions"
                                [colors]="colors"
                                [labels]="labels"
                                [data]="chartData"
                            >
                            </lsq-chart>
                        </div>
                        <div
                            class="chart-container"
                            *ngIf="(agingOverviewData$ | async)?.invoiceCount === 0"
                        >
                            <div
                                *ngIf="!debtorKey"
                                class="chart-center chart-blank-slate"
                                i18n="Message displayed when the invoice aging chart has no data"
                            >
                                There are no open invoices to display right now.
                            </div>
                            <div
                                *ngIf="debtorKey"
                                class="chart-center chart-blank-slate"
                                i18n="
                                    Message displayed when the invoice aging chart for a customer
                                    has no data
                                "
                            >
                                There are no open invoices with this customer right now.
                            </div>
                            <lsq-chart
                                class="doughnut-chart"
                                [options]="chartOptions"
                                [colors]="[blankChartColor]"
                                [labels]="labels"
                                [data]="[100]"
                            >
                            </lsq-chart>
                        </div>
                        <div class="chart-legend">
                            <div class="chart-legend-section">
                                <div
                                    class="chart-legend-dot"
                                    [style.background-color]="colors[0]"
                                ></div>
                                <span class="chart-legend-label text-uppercase">{{
                                    labels[0]
                                }}</span>
                                <div class="chart-legend-dollar">
                                    {{
                                        (agingOverviewData$ | async)?.amountCurrent || 0 | currency
                                    }}
                                </div>
                                <div class="chart-legend-percent">
                                    {{
                                        (agingOverviewData$ | async)?.percentCurrent || 0 | percent
                                    }}
                                </div>
                            </div>
                            <div class="chart-legend-section">
                                <div
                                    class="chart-legend-dot"
                                    [style.background-color]="colors[1]"
                                ></div>
                                <span class="chart-legend-label text-uppercase">{{
                                    labels[1]
                                }}</span>
                                <div class="chart-legend-dollar">
                                    {{ (agingOverviewData$ | async)?.amountDayOne || 0 | currency }}
                                </div>
                                <div class="chart-legend-percent">
                                    {{ (agingOverviewData$ | async)?.percentDayOne || 0 | percent }}
                                </div>
                            </div>
                            <div class="chart-legend-section">
                                <div
                                    class="chart-legend-dot"
                                    [style.background-color]="colors[2]"
                                ></div>
                                <span class="chart-legend-label text-uppercase">{{
                                    labels[2]
                                }}</span>
                                <div class="chart-legend-dollar">
                                    {{
                                        (agingOverviewData$ | async)?.amountDayThirtyOne || 0
                                            | currency
                                    }}
                                </div>
                                <div class="chart-legend-percent">
                                    {{
                                        (agingOverviewData$ | async)?.percentDayThirtyOne || 0
                                            | percent
                                    }}
                                </div>
                            </div>
                            <div class="chart-legend-section">
                                <div
                                    class="chart-legend-dot"
                                    [style.background-color]="colors[3]"
                                ></div>
                                <span class="chart-legend-label text-uppercase">{{
                                    labels[3]
                                }}</span>
                                <div class="chart-legend-dollar">
                                    {{
                                        (agingOverviewData$ | async)?.amountDaySixtyOne || 0
                                            | currency
                                    }}
                                </div>
                                <div class="chart-legend-percent">
                                    {{
                                        (agingOverviewData$ | async)?.percentDaySixtyOne || 0
                                            | percent
                                    }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="!debtorKey" class="col-lg-6">
            <div id="sfn-card" class="card">
                <div class="card-header" i18n="Specialty Finance Network card header">
                    Specialty Finance Network
                </div>
                <div class="card-body">
                    <div [style.margin-bottom.rem]="1" class="text-center">
                        <lsq-icon [type]="icons.Puzzle" [width]="65" [height]="65"></lsq-icon>
                    </div>
                    <p i18n="Specialty Finance Network offer text">
                        Does your business have an additional need for equipment, inventory, or an
                        alternative form of financing? Continue to improve your cash flow and
                        liquidity using our trusted network of partners — who pair well with LSQ’s
                        Invoice Financing.
                    </p>
                    <div [style.margin-top.rem]="2">
                        <a
                            i18n="Specialty Finance Network email link"
                            class="preserve-case"
                            target="_blank"
                            href="mailto:sfeatherston@lsq.com"
                            target="_blank"
                        >
                            Learn More About Our Partners
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="debtorKey && metricsDataSource" class="col-lg-6">
            <div id="metrics-card" [ngClass]="{ card: !isMobile }">
                <div *ngIf="!isMobile" class="card-header" i18n="Metrics card header">
                    Metrics
                </div>
                <div [ngClass]="{ 'card-body': !isMobile }" class="metrics-body">
                    <div *ngIf="metricsDataSource.loading$ | async" class="container-fluid">
                        <lsq-circle-loader></lsq-circle-loader>
                    </div>
                    <div *ngIf="!(metricsDataSource.loading$ | async)" class="metrics-inner">
                        <div class="metrics-item mobile-amount-cluster-card text-right narrow">
                            <dashboard-amount-cluster
                                label="# of Invoices Purchased"
                                i18n-label="
                                    # of Invoices Purchased customer metrics dashboard label
                                "
                                [value]="(metricsData$ | async)?.metrics?.purchasedInvoiceCount"
                            >
                            </dashboard-amount-cluster>
                        </div>
                        <div class="metrics-item mobile-amount-cluster-card text-right narrow">
                            <dashboard-amount-cluster
                                [usePercentPipe]="true"
                                label="Dilution Rate"
                                i18n-label="Dilution Rate customer metrics dashboard label"
                                tooltipText="The percentage difference between the amount that you invoiced your customer and what your customer actually paid."
                                i18n-tooltipText="Dilution Rate customer metrics dashboard tooltip"
                                [value]="(metricsData$ | async)?.metrics?.dilution"
                            >
                            </dashboard-amount-cluster>
                        </div>
                        <div class="metrics-item mobile-amount-cluster-card text-right wide">
                            <dashboard-amount-cluster
                                [useCurrencyPipe]="true"
                                label="Average Invoice Size"
                                i18n-label="Average Invoice Size customer metrics dashboard label"
                                [value]="(metricsData$ | async)?.metrics?.averageInvoiceSize"
                            >
                            </dashboard-amount-cluster>
                        </div>
                        <div class="metrics-item mobile-amount-cluster-card text-right narrow">
                            <dashboard-amount-cluster
                                label="# of Invoices Paid"
                                i18n-label="# of Invoices Paid customer metrics dashboard label"
                                [value]="(metricsData$ | async)?.metrics?.paidInvoiceCount"
                            >
                            </dashboard-amount-cluster>
                        </div>
                        <div class="metrics-item mobile-amount-cluster-card text-right narrow">
                            <dashboard-amount-cluster
                                label="Average Days to Pay"
                                i18n-label="Average Days to Pay customer metrics dashboard label"
                                tooltipText="The average number of days it takes for your customer to pay your invoices."
                                i18n-tooltipText="
                                    Average Days to Pay customer metrics dashboard tooltip
                                "
                                [value]="
                                    (metricsData$ | async)?.metrics?.averageDaysToPay || nullAmount
                                "
                            >
                            </dashboard-amount-cluster>
                        </div>
                        <div class="metrics-item mobile-amount-cluster-card text-right wide">
                            <dashboard-amount-cluster
                                [useCurrencyPipe]="
                                    !!(metricsData$ | async)?.metrics?.lastPaymentAmount
                                "
                                label="Last Payment Received"
                                i18n-label="Last Payment Received customer metrics dashboard label"
                                [value]="
                                    (metricsData$ | async)?.metrics?.lastPaymentAmount || nullAmount
                                "
                            >
                            </dashboard-amount-cluster>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
